import { oc } from '@orpc/contract';
import { listTemplatesInputSchema, listTemplatesOutputSchema } from '../schemas/templates.schemas.js';
export const listTemplatesContract = oc
    .route({
    method: 'GET',
    path: '/templates',
    tags: ['Templates'],
    summary: 'List the templates of the caller’s tenant; archived ones are hidden by default',
})
    .input(listTemplatesInputSchema)
    .output(listTemplatesOutputSchema);
//# sourceMappingURL=list-templates.contract.js.map